import { MarketplaceUser, SupportedCountry } from 'models/types/Marketplace';
import { MarketplaceTypes } from 'redux/actions/marketplaceAction';

interface MarketplaceState {
  loading: boolean;
  loadingCategory: boolean;
  user: MarketplaceUser | null;
  userAddress: any;
  category: any;
  cart: any;
  supportedCountries: SupportedCountry[];
  marketplaceTheme: any;
  softwareData: any[];
  listRequestsOpen: any[];
  listRequestsClosed: any[];
  isLoadingRequestsOpen: boolean;
  isLoadingRequestsClosed: boolean;
  totalMarketplaceRequestsOpen: number;
  totalSNOWRequestsOpen: number;
  totalItemsRequestsOpen: number;
  totalMarketplaceRequestsClosed: number;
  totalSNOWRequestsClosed: number;
  totalItemsRequestsClosed: number;
  listApprovalOpen: any[];
  listApprovalClosed: any[];
  isLoadingApprovalOpen: boolean;
  isLoadingApprovalClosed: boolean;
  totalMarketplaceApprovalOpen: number;
  totalSNOWApprovalOpen: number;
  totalItemsApprovalOpen: number;
  totalMarketplaceApprovalClosed: number;
  totalSNOWApprovalClosed: number;
  totalItemsApprovalClosed: number;
  requestsDateRange: any[];
  incDateRange: any[];
  approvalDateRange: any[];
  approver: any[];
  ticketStatusChange: string;
}

const defaultState: MarketplaceState = {
  loading: false,
  loadingCategory: true,
  user: null,
  userAddress: [],
  category: [],
  cart: [],
  supportedCountries: [],
  marketplaceTheme: null,
  softwareData: [],
  listRequestsOpen: [],
  listRequestsClosed: [],
  isLoadingRequestsOpen: false,
  isLoadingRequestsClosed: false,
  totalMarketplaceRequestsOpen: 0,
  totalSNOWRequestsOpen: 0,
  totalItemsRequestsOpen: 0,
  totalMarketplaceRequestsClosed: 0,
  totalSNOWRequestsClosed: 0,
  totalItemsRequestsClosed: 0,
  listApprovalOpen: [],
  listApprovalClosed: [],
  isLoadingApprovalOpen: false,
  isLoadingApprovalClosed: false,
  totalMarketplaceApprovalOpen: 0,
  totalSNOWApprovalOpen: 0,
  totalItemsApprovalOpen: 0,
  totalMarketplaceApprovalClosed: 0,
  totalSNOWApprovalClosed: 0,
  totalItemsApprovalClosed: 0,
  requestsDateRange: [],
  incDateRange: [],
  approvalDateRange: [],
  approver: [],
  ticketStatusChange: '',
};

const marketplaceReducer = (state = defaultState, action: any) => {
  const {
    user,
    category,
    userAddress,
    cart,
    supportedCountries,
    marketplaceTheme,
    softwareData,
    marketplaceRequestsOpen,
    marketplaceRequestsClosed,
    marketplaceApprovalOpen,
    marketplaceApprovalClosed,
    requestsDateRange,
    incDateRange,
    approvalDateRange,
    approver,
    ticketStatusChange,
  } = action;

  switch (action.type) {
    case MarketplaceTypes.GET_USER:
      return {
        ...state,
        loading: true,
      };
    case MarketplaceTypes.GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user,
      };
    case MarketplaceTypes.GET_CATEGORY:
      return {
        ...state,
        loadingCategory: true,
      };
    case MarketplaceTypes.GET_CART_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case MarketplaceTypes.GET_USER_ADDRESS:
      return {
        ...state,
        loading: true,
      };
    case MarketplaceTypes.GET_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddress,
      };
    case MarketplaceTypes.GET_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingCategory: false,
        category,
      }; 
    case MarketplaceTypes.GET_CART_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        cart,
      };
    case MarketplaceTypes.GET_SUPPORTED_COUNTRIES:
      return {
        ...state,
        loading: true,
      }; 
    case MarketplaceTypes.GET_SUPPORTED_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        supportedCountries: supportedCountries as SupportedCountry[],
      };
      case MarketplaceTypes.GET_MARKETPLACE_THEME:
      return {
        ...state,
        loading: true,
      }; 
    case MarketplaceTypes.GET_MARKETPLACE_THEME_SUCCESS:
      return {
        ...state,
        loading: false,
        marketplaceTheme
      };
    case MarketplaceTypes.GET_LIST_SOFTWARE_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
      };
    case MarketplaceTypes.GET_LIST_SOFTWARE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        softwareData
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_REQUESTS_OPEN:
      return {
        ...state,
        isLoadingRequestsOpen: true,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_REQUESTS_OPEN_SUCCESS:
      return {
        ...state,
        listRequestsOpen: marketplaceRequestsOpen.data,
        totalSNOWRequestsOpen: marketplaceRequestsOpen.totalSNOW,
        totalMarketplaceRequestsOpen: marketplaceRequestsOpen.totalMarketplace,
        totalItemsRequestsOpen: marketplaceRequestsOpen.totalItems,
        isLoadingRequestsOpen: false,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_REQUESTS_OPEN_FAIL:
      return {
        ...state,
        isLoadingRequestsOpen: false,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_REQUESTS_CLOSED:
      return {
        ...state,
        isLoadingRequestsClosed: true,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_REQUESTS_CLOSED_SUCCESS:
      return {
        ...state,
        listRequestsClosed: marketplaceRequestsClosed.data,
        totalSNOWRequestsClosed: marketplaceRequestsClosed.totalSNOW,
        totalMarketplaceRequestsClosed: marketplaceRequestsClosed.totalMarketplace,
        totalItemsRequestsClosed: marketplaceRequestsClosed.totalItems,
        isLoadingRequestsClosed: false,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_REQUESTS_CLOSED_FAIL:
      return {
        ...state,
        isLoadingRequestsClosed: false,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_APPROVAL_OPEN:
      return {
        ...state,
        isLoadingApprovalOpen: true,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_APPROVAL_OPEN_SUCCESS:
      return {
        ...state,
        listApprovalOpen: marketplaceApprovalOpen.data,
        totalSNOWApprovalOpen: marketplaceApprovalOpen.totalSNOW,
        totalMarketplaceApprovalOpen: marketplaceApprovalOpen.totalMarketplace,
        totalItemsApprovalOpen: marketplaceApprovalOpen.totalItems,
        isLoadingApprovalOpen: false,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_APPROVAL_OPEN_FAIL:
      return {
        ...state,
        isLoadingApprovalOpen: false,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_APPROVAL_CLOSED:
      return {
        ...state,
        isLoadingApprovalClosed: true,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_APPROVAL_CLOSED_SUCCESS:
      return {
        ...state,
        listApprovalClosed: marketplaceApprovalClosed.data,
        totalSNOWApprovalClosed: marketplaceApprovalClosed.totalSNOW,
        totalMarketplaceApprovalClosed: marketplaceApprovalClosed.totalMarketplace,
        totalItemsApprovalClosed: marketplaceApprovalClosed.totalItems,
        isLoadingApprovalClosed: false,
      };
    case MarketplaceTypes.GET_ALL_MARKETPLACE_APPROVAL_CLOSED_FAIL:
      return {
        ...state,
        isLoadingApprovalClosed: false,
      };
    case MarketplaceTypes.SET_REQUESTS_DATE_RANGE:
      return {
        ...state,
        requestsDateRange,
      };
    case MarketplaceTypes.SET_INC_DATE_RANGE:
      return {
        ...state,
        incDateRange,
      };
    case MarketplaceTypes.SET_APPROVAL_DATE_RANGE:
      return {
        ...state,
        approvalDateRange,
      };
    case MarketplaceTypes.SET_APPROVER:
      return {
        ...state,
        approver,
      };
    case MarketplaceTypes.UPDATE_TICKET_STATUS:
      return {
        ...state,
        ticketStatusChange,
      };
    default:
      return state;
  }
};

export default marketplaceReducer;
